import { render, staticRenderFns } from "./email.vue?vue&type=template&id=6fc8be97&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc8be97')) {
      api.createRecord('6fc8be97', component.options)
    } else {
      api.reload('6fc8be97', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=6fc8be97&", function () {
      api.rerender('6fc8be97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/email.vue"
export default component.exports